import { BuilkComponent } from "./builk.component";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { CollapseModule } from 'ngx-bootstrap/collapse';

// Import Module
import { BuilkRoutingModule } from "./builk-routing.module";
import { SharedModule } from "../shared/shared.module";
import { UserManagerModule } from "./user-manager/user-manager.module";
import { CustomCostCodeModule } from "./custom-costcode/custom-costcode.module";
import { ProFunnelModule } from "./profunnel/profunnel.module";
import { CouponSettingModule } from "./coupon-setting/coupon-setting.module";

// Import Component
import { UserManagerComponent } from "./user-manager/user-manager.component";
import { ProFunnelComponent } from "./profunnel/profunnel.component";
import { ProFunnelCommentComponent } from "./profunnel/profunnel-comment/profunnel-comment.component";
import { ProFunnelButtonComponent } from "./profunnel/profunnel-button/profunnel-button.component";
import { ProFunnelRefreshComponent } from "./profunnel/profunnel-refresh/profunnel-refresh.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { PoItemComponent } from "./po-item/po-item.component";
import { PoItemModule } from "./po-item/po-item.module";
import { BuilkSharedModule } from "./shared/shared.module";
import { LoadingModule } from "ngx-loading";
import { ImageAppComponent } from "./image-app/image-app.component";
import { ImageAppAddComponent } from './image-app/image-app-add/image-app-add.component';
import { ImageAppConfirmUpdateStatusComponent } from './image-app/image-app-confirm-update-status/image-app-confirm-update-status.component';
import { ImageAppDetailComponent } from './image-app/image-app-detail/image-app-detail.component';
import { ImageTipSettingModule } from "./image-tip-setting/image-tip-setting.module";
import { PackageSaleModule } from "./package-sale/package-sale.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { VoucherModule } from "./voucher/voucher.module";
import { MybuilkModule } from "./mybuilk/mybuilk.module";
import { BannerListModule } from "./banner-list/banner-list.module";
import {BsDatepickerModule} from "ngx-bootstrap";
import { CustomCostcodeSaleModule } from "./custom-costcode-sale/custom-costcode-sale.module";

@NgModule({
    imports: [
        FormsModule,
        BrowserModule,
        BuilkRoutingModule,
        SharedModule,
        UserManagerModule,
        CustomCostCodeModule,
        ProFunnelModule,
        PoItemModule,
        NgSelectModule,
        BuilkSharedModule,
        LoadingModule,
        CouponSettingModule,
        ImageTipSettingModule,
        PackageSaleModule,
        DashboardModule,
        VoucherModule,
        CollapseModule,
        MybuilkModule,
        BannerListModule,
        BsDatepickerModule,
        CustomCostcodeSaleModule,
    ],
    declarations: [
        UserManagerComponent,
        BuilkComponent,
        ProFunnelComponent,
        ProFunnelCommentComponent,
        ProFunnelButtonComponent,
        ProFunnelRefreshComponent,
        PoItemComponent,
        ImageAppComponent,
        ImageAppAddComponent,
        ImageAppConfirmUpdateStatusComponent,
        ImageAppDetailComponent,
    ],
    entryComponents: [
        ProFunnelCommentComponent,
        ProFunnelButtonComponent,
        ProFunnelRefreshComponent
    ]
})

export class BuilkModule { }
